/**
* Featured Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
// import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'featured-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const selectedButton = document.getElementById( 'selected-button' );
      const toggleButtons = document.querySelectorAll( '.featured-services__toggle' );

      const textSpan = selectedButton.querySelector( 'span' );

      toggleButtons.forEach( ( button ) => {
        button.addEventListener( 'click', () => {
          const category = button.getAttribute( 'data-category' );
          if ( category ) {
            textSpan.textContent = category;
          }
        } );
      } );

      // Handle default active button
      const defaultActiveButton = document.querySelector( '[data-toggle-is-active]' );
      if ( defaultActiveButton && textSpan.textContent.trim() === textSpan.dataset.initialText ) {
        textSpan.textContent = defaultActiveButton.getAttribute( 'data-category' );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-services', COMPONENT );
} )( app );
